__turbopack_context__.v({
  "MediaOverlayContainer": "Project-module-scss-module__wpDOla__MediaOverlayContainer",
  "externalLinkIcon": "Project-module-scss-module__wpDOla__externalLinkIcon",
  "hidden": "Project-module-scss-module__wpDOla__hidden",
  "hoverContent": "Project-module-scss-module__wpDOla__hoverContent",
  "imageWrapper": "Project-module-scss-module__wpDOla__imageWrapper",
  "mediaOverlay": "Project-module-scss-module__wpDOla__mediaOverlay",
  "project": "Project-module-scss-module__wpDOla__project",
  "projectImage": "Project-module-scss-module__wpDOla__projectImage",
  "projectMobile": "Project-module-scss-module__wpDOla__projectMobile",
  "projectName": "Project-module-scss-module__wpDOla__projectName",
  "viewWebsiteLink": "Project-module-scss-module__wpDOla__viewWebsiteLink",
});
